import { message } from "antd";
import axios from "axios";
import API_MAP from "../../services/uri";
import errorHandler from "./errorHandler";

export const createPlanTag = async (credential) => {
	try {
		const response = await axios.post(
			`${API_MAP.createPlanTag}`,
			credential
		);
		const { hasError } = response.data;
		if (hasError) {
			message.error(response.data.errors.message);
			console.log("Get create tag data res =====> \n", response);
		} else {
			return response;
		}
	} catch (error) {
		return errorHandler(error);
	}
};

export const fetchPlanTags = async () => {
	try {
		const response = await axios.get(`${API_MAP.viewPlanTag}`);
		const { hasError } = response.data;
		if (hasError) {
			message.error(response.data.errors.message);
			console.log("Get plan tag data res =====> \n", response);
		} else {
			return response.data;
		}
	} catch (error) {
		return errorHandler(error);
	}
};

export const addPlan = async (credentials) => {
	try {
		const response = await axios.post(`${API_MAP.addPlan}`, credentials);
		const { hasError } = response.data;
		if (hasError) {
			message.error(response.data.errors.message);
			console.log("Add plan tag data res =====> \n", response);
		} else {
			return response.data;
		}
	} catch (error) {
		return errorHandler(error);
	}
};

export const editPlan = async (credentials) => {
	try {
		const response = await axios.put(`${API_MAP.editPlan}`, credentials);
		const { hasError } = response.data;
		if (hasError) {
			message.error(response.data.errors.message);
			console.log("Edit plan data res =====> \n", response);
		} else {
			return response.data;
		}
	} catch (error) {
		return errorHandler(error);
	}
};

export const fetchPlans = async ({ filter, tag }) => {
	try {
		const response = await axios.get(
			`${API_MAP.viewPlans}?filter=${filter || "all"}&tag=${tag}`
		);
		const { hasError } = response.data;
		if (hasError) {
			message.error(response.data.errors.message);
			console.log("Get plan data res =====> \n", response);
		} else {
			return response.data;
		}
	} catch (error) {
		return errorHandler(error);
	}
};

export const updatePlanProgress = async (credentials) => {
	try {
		const response = await axios.put(`${API_MAP.updatePlan}`, credentials);
		const { hasError } = response.data;
		if (hasError) {
			console.log("Get update plan data res =====> \n", response);
			errorHandler(response.data.errors);
		} else {
			return response.data;
		}
	} catch (error) {
		return errorHandler(error);
	}
};

export const deletePlan = async (credentials) => {
	try {
		const response = await axios.delete(
			`${API_MAP.deletePlan}?planId=${credentials}`
		);
		const { hasError } = response.data;
		if (hasError) {
			console.log("\nDelete plan data res =====> \n", response);
			errorHandler(response.data.errors);
		} else {
			return response.data;
		}
	} catch (error) {
		return errorHandler(error);
	}
};

export const addTag = async (credentials) => {
	try {
		const response = await axios.put(`${API_MAP.addTag}`, credentials);
		const { hasError } = response.data;
		if (hasError) {
			console.log("add tag to plan data res =====> \n", response);
			errorHandler(response.data.errors);
		} else {
			return response.data;
		}
	} catch (error) {
		return errorHandler(error);
	}
};

export const removeTag = async (credentials) => {
	try {
		const response = await axios.put(`${API_MAP.removeTag}`, credentials);
		const { hasError } = response.data;
		if (hasError) {
			console.log("remove tag to plan data res =====> \n", response);
			errorHandler(response.data.errors);
		} else {
			return response.data;
		}
	} catch (error) {
		return errorHandler(error);
	}
};
